import { MrfiktivParsedMimeMailAddressValueViewmodelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";

@IsFilterable
class MessageHeadersParsedMimeMailAddressValueBase implements MrfiktivParsedMimeMailAddressValueViewmodelGen {
  @FilterConfig({ type: FilterTypes.STRING })
  address: string;

  @FilterConfig({ type: FilterTypes.STRING })
  name?: string;

  get readable(): string {
    return this.name ? `${this.name} <${this.address}>` : this.address;
  }

  constructor(src?: Partial<IMessageHeadersParsedMimeMailAddressValue>) {
    this.address = src?.address || "";
    this.name = src?.name || "";
  }
}
type IMessageHeadersParsedMimeMailAddressValue = MessageHeadersParsedMimeMailAddressValueBase;
const MessageHeadersParsedMimeMailAddressValue = Filter.createForClass(MessageHeadersParsedMimeMailAddressValueBase);
export { IMessageHeadersParsedMimeMailAddressValue, MessageHeadersParsedMimeMailAddressValue };
